// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__uXAxt","tab":"UserNav_tab__16Jci"};